/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Typescript_Ref_N1Inputs */

const en_to_typescript_ref_n1 = /** @type {(inputs: To_Typescript_Ref_N1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Straightforward. All JSON numbers become number, integer or not.`)
};

const ko_to_typescript_ref_n1 = /** @type {(inputs: To_Typescript_Ref_N1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`단순합니다. 정수든 아니든 모든 JSON 숫자는 number가 됩니다.`)
};

const ja_to_typescript_ref_n1 = /** @type {(inputs: To_Typescript_Ref_N1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`単純です。整数かどうかにかかわらず、すべての JSON 数値は number になります。`)
};

/**
* | output |
* | --- |
* | "Straightforward. All JSON numbers become number, integer or not." |
*
* @param {To_Typescript_Ref_N1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_typescript_ref_n1 = /** @type {((inputs?: To_Typescript_Ref_N1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Typescript_Ref_N1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_typescript_ref_n1(inputs)
	if (locale === "ko") return ko_to_typescript_ref_n1(inputs)
	return ja_to_typescript_ref_n1(inputs)
});